module.exports = __webpack_public_path__ + "static/media/surprised-emoji-svgrepo-com (1).bef52651.svg";